import { render, staticRenderFns } from "./VLoading.vue?vue&type=template&id=5b82d577&scoped=true&"
import script from "./VLoading.vue?vue&type=script&lang=ts&"
export * from "./VLoading.vue?vue&type=script&lang=ts&"
import style0 from "./VLoading.vue?vue&type=style&index=0&id=5b82d577&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b82d577",
  null
  
)

export default component.exports